import { Seo } from "@/components/Seo";
import { useLanguage } from "../i18n";

export default function CookiePolicy() {
  const { t } = useLanguage();
  return (
    <>
      <Seo title="Cookie Policy — Alsera Studio" description={t("Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto funzionamento delle pagine e del sistema di prenotazione. Non vengono utilizzati cookie di profilazione propri.")} />
      <section className="pt-32 pb-24 sm:pt-40" data-testid="cookie-page">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <p className="eyebrow">{t("Documento legale")}</p>
          <h1 className="mt-4 text-3xl font-extrabold tracking-tight text-antracite sm:text-4xl">Cookie Policy</h1>
          <div className="mt-8 space-y-6 text-sm leading-relaxed text-antracite/75 sm:text-base">
            <p>{t("Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto funzionamento delle pagine e del sistema di prenotazione. Non vengono utilizzati cookie di profilazione propri.")}</p>
            <h2 className="text-xl font-bold text-antracite">{t("Cookie tecnici")}</h2>
            <p>{t("I cookie tecnici permettono la navigazione e l'utilizzo delle funzionalità del sito (ad esempio la compilazione dei moduli). Non richiedono il consenso dell'utente.")}</p>
            <h2 className="text-xl font-bold text-antracite">{t("Strumenti di terze parti")}</h2>
            <p>{t("Il sito può appoggiarsi a servizi tecnici di terze parti per l'hosting e l'analisi aggregata del traffico. Eventuali strumenti di misurazione verranno indicati qui con le relative informative non appena attivati.")}</p>
            <h2 className="text-xl font-bold text-antracite">{t("Gestione delle preferenze")}</h2>
            <p>{t("Puoi gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser. La disattivazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito.")}</p>
            <p className="rounded-2xl bg-acqua/50 p-4 text-sm">{t("Nota: questo documento è un modello generale da personalizzare prima della pubblicazione definitiva.")}</p>
          </div>
        </div>
      </section>
    </>
  );
}
